
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 18","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_56_819)"}},[_c('path',{attrs:{"d":"M6.282 17.344c.421.42.995.658 1.593.658.567 0 1.17-.235 1.593-.658a2.312 2.312 0 00.658-1.593h-4.5c0 .567.235 1.17.658 1.593h-.002zm8.924-4.884a6.778 6.778 0 01-1.106-1.711 4.35 4.35 0 01-1.613.31 4.38 4.38 0 01-4.374-4.374 4.38 4.38 0 012.825-4.09A5.6 5.6 0 009 1.8v-.675a1.124 1.124 0 10-2.249 0V1.8a5.596 5.596 0 00-4.5 5.513v.661A6.75 6.75 0 01.546 12.46l-.26.291a1.126 1.126 0 00.84 1.875h13.5a1.126 1.126 0 00.84-1.875l-.26-.291h.001z"}}),_c('path',{attrs:{"d":"M9.156 6.685a3.33 3.33 0 004.589 3.083 3.33 3.33 0 00-1.823-6.366 3.33 3.33 0 00-2.764 3.28l-.002.003zm1.824-.257a.361.361 0 01.257-.106c.093 0 .188.035.257.106l.576.576 1.219-1.218.19-.19a.361.361 0 01.257-.105.365.365 0 01.257.621l-.534.534-1.132 1.132a.362.362 0 01-.257.106.359.359 0 01-.257-.106l-.833-.833a.365.365 0 010-.516v-.001z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_56_819"}},[_c('path',{attrs:{"d":"M0 0h15.819v18H0z"}})])])])
          )
        }
      }
    